module.exports = __webpack_public_path__ + "img/tsinghua-fintech-institute.40be6e0f.png";